<template>
  <div class="project__item project__columns">
    <div class="project__column">
      <div class="project__product">
        <div class="project__image">
          <img v-if="item.baseElement.previewImageUrl !== ''" :src="item.baseElement.previewImageUrl" :alt="item.baseElement.title">
        </div>
        <div class="project__info">
          <h2 class="headingFive">{{ item.baseElement.title }}</h2>
          <p class="project__sku">{{ item.baseElement.sku }}</p>

          <div v-if="item.type == 'fitted' || item.type == 'fitted-gtl'">
            <p class="paragraphSmall">{{ item.baseElement.shortDescription }}</p>
            <div v-if="item.type == 'fitted'">
              <h3 class="finishSwatch__heading paragraph">Available {{ item.baseElement.title }} finishes:</h3>
              <ul class="finishSwatch">
                <li v-for="finish in item.baseElement.finishes" :key="finish.title" class="finishSwatch__item" :title="finish.title">
                  <div class="finishSwatch__swatch" :style=" { 'background-color': finish.colour }" />
                </li>
              </ul>
            </div>
            

            <ul v-if="item.baseElement.files.length > 0" class="project__downloads downloadBlock">
              <li v-for="file in item.baseElement.files" :key="file.url" class="downloadBlock__item">
                <a :href="file.url" target="_blank">{{ file.title }}</a>
              </li>
            </ul>
          </div>
          <div v-else>
            <ul class="project__specs">
              <li><span>Item:</span><a :href="item.baseElement.url">{{ item.baseElement.title }}</a></li>
              <li v-if="item.type == 'builder'"><span>Finish:</span>{{ item.baseElement.finishDisplayName }}</li>
              <li v-for="(option, key) in item.options" :key="key">
                <span v-if="key == 'arm'">Option:</span>
                <span v-else>{{ capitalize(key) }}:</span>
                <div v-if="option.constructor === Array" class="project__speclist">
                  <span v-for="optionItem in option" :key="optionItem.title" class="project__option"><a :href="optionItem.url">{{ optionItem.title }}</a>, {{ optionItem.sku }}</span>
                </div>
                <span v-else class="project__option"><a :href="option.url">{{ option.title }}</a>, {{ option.sku }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="project__related productCards">
        <a v-for="preview in previews" :key="preview.title" :href="preview.url" class="productCards__item project__specimage">
          <div v-if="preview.previewImageUrl !== ''" title="image title" class="productCards__image" :style="{ 'background-image': 'url('+ preview.previewImageUrl + ')' }" />
          <h2 class="headingFive">{{ preview.title }}</h2>
        </a>
      </div>
    </div>

    <div class="project__column">
      <form class="form">
        <div class="form__row">
          <input v-model="qty" type="number" placeholder="QTY">
        </div>
      </form>
    </div>

    <div class="project__column">
      <span v-if="item.total > 0">
        <p class="project__price headingFive">{{ total }}</p>
      </span>
    </div>

    <div class="project__column">
      <form class="form">
        <div class="form__row">
          <textarea v-model="notes" rows="5" placeholder="Project notes" />
        </div>
      </form>
      <div class="project__options">
        <span :class="{'project__saved--active': itemSaved }" class="project__saved italic">Item updated.</span>
        <a href="" class="button button--text" @click.prevent="removeItem(item.id)">Remove</a>
        <a href="" class="button" @click.prevent="saveItemDetails">Update</a>
      </div>
    </div>
  </div>
</template>
<script>
import axios from '../config/axios';

export default {
	props: {
		item: {
			type: Object,
			default: null
		}
	},
	data() {
		return {
			qty: this.item.qty,
			notes: this.item.notes,
			itemSaved: false
		};
	},
	computed: {
		total: function () {
			return (this.item.total * this.qty).toLocaleString('en-GB', { style: 'currency', currency: 'GBP' });
		},
		previews() {
			const previews = [];

			Object.keys(this.item.options).forEach((key) => {
				if(this.item.options[key].constructor === Array) {
					for(let i = 0; i < this.item.options[key].length; i++) {
						previews.push(this.item.options[key][i]);
					}
				} else {
					previews.push(this.item.options[key]);
				}
			});

			return previews;
		}
	},
	methods: {
		saveItemDetails() {
			const self = this;

			const data = {
				id: this.item.id,
				quantity: this.qty,
				notes: this.notes
			};

			axios.post('/actions/projectbook/project-item/save-details', data)
			.then(() => {
				self.itemSaved = true;

				setTimeout(() => {
					self.itemSaved = false;
				}, 3500);
			});
		},
		removeItem() {
			this.$emit("remove");
		},
		capitalize(value) {
			if (!value) return '';

			value = value.toString();
			return value.charAt(0).toUpperCase() + value.slice(1);
		}
	}
};
</script>
